import Default from '../../layouts/default';
import Cadastro from '../../layouts/cadastro';


const publicRoutes = [
  { path: '/concluir-cadastro', component: Cadastro },
  { path: '/sucesso', component: Cadastro },
  { component: Cadastro }
];

export default publicRoutes;
